(function() {
    'use strict';

    angular.
        module('valueconnectApp.auditEntry', [])
        .component('auditEntry', {
            templateUrl: 'app/components/audit/audit-entry.template.html',
            bindings: {
                audit: '<',
                hideHeadings: '<'
            },
            controllerAs: 'vm',
            controller: ['$log', '$scope', '$state', '$sce',
            function auditEntry($log, $scope, $state, $sce) {
                var vm = this;
                vm.printLogData = printLogData;
                vm.showLogDetails = showLogDetails;
                vm.toggleQuoteSnapshot = toggleQuoteSnapshot;
                vm.logToggle = [];
                vm.quoteSnapshotToggle = [];
                vm.detailedLogTypes = ['EMAIL', 'BOUNCE_EMAIL_NOTIFY'];

                vm.$onInit = function() {
                    syncAndParse();
                };

                vm.$onChanges = function(changes) {
                    if (changes.audit) {
                        syncAndParse();
                    }
                };

                function syncAndParse() {
                    vm.parsedQuoteSnapshot = null;
                    if (!vm.audit) {
                        return;
                    }
                    if (!vm.audit.auditEventType && vm.audit.type) {
                        vm.audit.auditEventType = vm.audit.type;
                    }
                    if (vm.audit.data && vm.audit.data.snapshot) {
                        try {
                            vm.parsedQuoteSnapshot = angular.fromJson(vm.audit.data.snapshot);
                        } catch (e) {
                            $log.warn('audit-entry: invalid QUOTE_SNAPSHOT json', e);
                        }
                    }
                }

                function toggleQuoteSnapshot(log) {
                    vm.quoteSnapshotToggle[log.id] = !vm.quoteSnapshotToggle[log.id];
                }

                function printLogData(log, key, data) {
                    if (log.auditEventType === 'EMAIL' && key === 'content') {
                        return $sce.trustAsHtml(data);
                    } else if (log.auditEventType === 'ORDER_UPDATE_ATTEMPT' && key === 'Attempted Changes') {
                        return $sce.trustAsHtml(data.replace(/\n\n/g, '<br/><br/>').replace(/\n/g, '<br/>'));
                    } else if (key === 'Manual Quote Region') {
                        return $sce.trustAsHtml(data || '');
                    } else if (key === 'Manual Quote Reasons') {
                        return $sce.trustAsHtml((data || '').replace(/\n\n/g, '<br/><br/>').replace(/\n/g, '<br/>'));
                    } else {
                        return data;
                    }

                }

                function showLogDetails(log) {
                    vm.logToggle[log.id] = !(vm.logToggle[log.id] | false);
                }

            }]
        });
})();
